import StartAction from "./StartAction";

export default StartAction;
